import React from "react";
import { motion } from "framer-motion";

export default function Timeline({ items = [] }) {
  return (
    <ol data-testid="career-timeline" className="relative border-l hairline pl-6 md:pl-10 space-y-10 md:space-y-14">
      {items.map((it, i) => (
        <motion.li
          key={`${it.year}-${it.org}`}
          initial={{ opacity: 0, x: -16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.05 }}
          className="relative"
          data-testid={`timeline-item-${i}`}
        >
          <span className="absolute -left-[34px] md:-left-[44px] top-2 w-3 h-3 rounded-full bg-black ring-4 ring-white" />
          <div className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-8">
            <div className="md:col-span-2">
              <span className="font-serif-display text-2xl md:text-3xl text-black">
                {it.year}
              </span>
            </div>
            <div className="md:col-span-10">
              <h3 className="text-lg md:text-xl text-black font-medium">
                {it.role} · <span className="text-gray-500 font-light">{it.org}</span>
              </h3>
              <p className="mt-2 text-base text-gray-600 font-light leading-relaxed max-w-3xl">
                {it.desc}
              </p>
            </div>
          </div>
        </motion.li>
      ))}
    </ol>
  );
}
